import { actions } from './actions';



export const reducers = [
    [
        actions.init,
        (state, action) => {
            const {
                isMobile,code,error,searchType
            } = action.payload;

            if(error){
                return {...state,init:true,error};
            }

    
            return {
                init:true,
                searchType,
                isMobile,
                code,
                error
            };
        }
    ]
];
